<template>
  <v-card>
    <v-flex xs12>
      <v-list one-line>
        <template v-for="(document, index) in documents">
          <v-list-item :key="document.url">
            <v-list-item-avatar>
              <v-icon large>{{ icon(document) }}</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-html="document.file_name"></v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon ripple @click="remove(index)">
                <v-icon color="grey lighten-1">delete_forever</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-list>
    </v-flex>
  </v-card>
</template>

<script>
import _ from 'lodash';
import { mapActions } from 'vuex';

export default {
  name: 'uploaded-files',
  props: ['documents'],
  data: () => ({}),
  computed: {},
  methods: {
    ...mapActions(['updateUserBusinessRole']),
    icon: function(document) {
      const extension = _.last(_.split(document.file_name, '.'));
      switch (extension) {
        case 'doc':
        case 'docx':
        case 'odt':
          return 'fas fa-file-word';
        case 'xls':
        case 'xlsx':
        case 'ods':
        case 'csv':
          return 'fas fa-file-excel';
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
          return 'fas fa-file-image';
        case 'pdf':
          return 'fas fa-file-pdf';
        default:
          return 'fas fa-file-alt';
      }
    },
    remove: function(index) {
      this.$emit('remove', index);
    }
  }
};
</script>

<style scoped></style>
